import { useStoreValue } from '@/lib/react-hooks/generic-hooks'

export function useCompanyFeatureFlags() {
	return useStoreValue((s) => s.myCompany?.feature_flag ?? undefined)
}
